export default __webpack_public_path__ + "guide--imagery-sakurajima-960-cfa5be24d07f9b16b71b659a4f5af84a.png";